import { render, staticRenderFns } from "./hjManagement.vue?vue&type=template&id=2c1bedb7&scoped=true"
import script from "./hjManagement.vue?vue&type=script&lang=js"
export * from "./hjManagement.vue?vue&type=script&lang=js"
import style0 from "./hjManagement.vue?vue&type=style&index=0&id=2c1bedb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1bedb7",
  null
  
)

export default component.exports